'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'

/**
 * Footer category links.
 *
 * Fetched rather than hardcoded. The previous hardcoded list pointed at slugs
 * that do not exist anywhere (`hinged-segment-rings`, `barbells`, `studs`), so
 * every one of those links landed on an empty listing. Using
 * `?withProducts=1` guarantees each rendered link resolves to at least one
 * product, and the list keeps itself correct as inventory changes.
 */
export function FooterShopLinks() {
  const [categories, setCategories] = useState<{ name: string; slug: string }[]>([])

  useEffect(() => {
    fetch('/api/categories?withProducts=1')
      .then(r => (r.ok ? r.json() : null))
      .then(d => setCategories((d?.categories || []).slice(0, 4)))
      .catch(() => {})
  }, [])

  return (
    <ul className="space-y-2.5">
      <li>
        <Link href="/collections" className="text-orion-muted hover:text-orion-accent text-sm transition-colors">
          All Collections
        </Link>
      </li>
      {categories.map(cat => (
        <li key={cat.slug}>
          <Link
            href={`/collections?cat=${encodeURIComponent(cat.slug)}`}
            className="text-orion-muted hover:text-orion-accent text-sm transition-colors"
          >
            {cat.name}
          </Link>
        </li>
      ))}
    </ul>
  )
}